import classNames from 'classnames';
import { format, getMonth, getYear } from 'date-fns';
import { range } from 'lodash';
import { FC, useState } from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FieldRenderProps } from 'react-final-form';

import { parseDateForPicker } from '../../../utilities/parseDateForPicker';

const years = range(2000, getYear(new Date()) + 1, 1);
const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

type TableFilterDateFieldProps = ReactDatePickerProps &
  FieldRenderProps<string, HTMLElement, string> & {
    value: string;
    labelText: string;
  };

const TableFilterDateField: FC<TableFilterDateFieldProps> = ({
  input,
  labelText,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={classNames('relative z-10', { 'z-20': isOpen })}>
      <label
        htmlFor={input.name}
        className="absolute -top-2 left-2 z-10 inline-block bg-[linear-gradient(to_bottom,_var(--tw-gradient-stops))] from-gray-50 to-white px-1 text-xs font-medium text-gray-900"
      >
        {labelText || input.name}
      </label>
      <DatePicker
        id={input.name}
        selected={parseDateForPicker(input.value)}
        className="block w-full rounded-md border border-gray-300 bg-white py-2 pr-3 text-sm shadow-sm"
        dateFormat="M/d/y"
        onCalendarOpen={() => setIsOpen(true)}
        onCalendarClose={() => setIsOpen(false)}
        wrapperClassName="w-full"
        isClearable
        clearButtonClassName="after:!bg-secondaryBlue"
        {...props}
        onChange={(date: Date) => {
          if (!date) {
            input.onChange(undefined);
            return;
          }
          input.onChange(format(date, 'yyyy-MM-dd'));
        }}
        renderCustomHeader={({ date, changeYear, changeMonth }) => (
          <div className="m-2 flex gap-2">
            <select
              className="block w-full rounded-md border-gray-300 text-sm shadow-sm"
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <select
              className="block w-full rounded-md border-gray-300 text-sm shadow-sm"
              value={getYear(date)}
              onChange={({ target: { value } }) => {
                changeYear(Number(value));
              }}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        )}
      />
    </div>
  );
};

export default TableFilterDateField;
